
import $ from 'jquery';
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import Quill from '../quill/Quill';

export type SendEvent<T> = { context: T, subject: string, html: string };

@Component({
  components: { Quill },
})
export default class EmailModal<T> extends Vue {
  @Prop({
    default: function () {// needs to be a function, not lambda, or else this will set to wrong instance
      return (this as EmailModal<T>).$t('emailModal.title');
    },
  })
  title!: string;
  @Prop({
    default: function () {// needs to be a function, not lambda, or else this will set to wrong instance
      return (this as EmailModal<T>).$t('emailModal.send');
    },
  })
  sendButtonText!: string;

  context: T | null = null;
  subject: string = '';
  html: string = '';

  public open(context: T, subject: string, html: string): void {
    this.context = context;
    this.subject = subject;
    this.html = html;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }
}
